import { InjectionToken } from '@angular/core';
import { ClosetDoorsCustomComponent } from '../pages/configurators-2d/closet-doors/custom/closet-doors-custom.component';
import { DeckingBoardsComponent } from '../pages/configurators-2d/decking-boards/decking-boards.component';
import { FenceComponent } from '../pages/configurators-2d/fence/fence.component';
import { WorkbenchComponent } from '../pages/configurators-2d/workbench/workbench.components';
import { CarpentryComponent } from '../pages/configurators-2d/carpentry/carpentry.component';

export const CLOSET_DOORS_CUSTOM_CONFIGURATOR = new InjectionToken(typeof ClosetDoorsCustomComponent);
export const FENCE_CONFIGURATOR = new InjectionToken(typeof FenceComponent);
export const DECKING_BOARDS_CONFIGURATOR = new InjectionToken(typeof DeckingBoardsComponent);
export const WORKBENCH_CONFIGURATOR = new InjectionToken(typeof WorkbenchComponent);
export const CARPENTRY_CONFIGURATOR = new InjectionToken(typeof CarpentryComponent);

export const configuratorProviders = [
  {
    provide: CLOSET_DOORS_CUSTOM_CONFIGURATOR,
    useClass: ClosetDoorsCustomComponent,
  },
  {
    provide: FENCE_CONFIGURATOR,
    useClass: FenceComponent,
  },
  {
    provide: DECKING_BOARDS_CONFIGURATOR,
    useClass: DeckingBoardsComponent,
  },
  {
    provide: WORKBENCH_CONFIGURATOR,
    useClass: WorkbenchComponent,
  },
  {
    provide: CARPENTRY_CONFIGURATOR,
    useClass: CarpentryComponent,
  },
];
